// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__Rwugl","select":"Header_select__2LyLY","clinic":"Header_clinic__19JLB"};